import { KEYWORD_MAPPING } from "constant";

const TypeMapping = {
  in: "in",
  contains: "",
  between: "between",
  equals: "equals",
  notIn: "not",
  greaterThan: ">",
  lessThan: "<",
  lessThanOrEqual: "<=",
  greaterThanOrEqual: ">=",
  notEquals: "not",
  isNetNew: "isNetNew",
};

type PropsItem = {
  key: string;
  value: { filter: string; type: keyof typeof KEYWORD_MAPPING };
};
const factorMappings = [
  {
    code: "10",
    value: "Product",
  },
  {
    code: "20",
    value: "Operations",
  },
  {
    code: "30",
    value: "Sales/Partners",
  },
  {
    code: "40",
    value: "Customer",
  },
];

export const TransformTooltips = (props: { item: PropsItem }) => {
  const { item } = props;
  const { key, value } = item;
  const symbol = TypeMapping[value.type] || "";
  if (key === "externalEPFilter") {
    const [epValue, epType] = value.filter.split("+");
    return epType === "ep" ? `epRequired ${epValue}` : epValue;
  }
  if (key === "renewalFactors") {
    return value.filter
      .split("|")
      .map((i) => factorMappings.find((j) => j.code === i)?.value)
      .join();
  }
  if (symbol === "in") {
    return value?.filter?.toString().split("|").join(", ");
  }
  if (symbol === "equals") {
    if (value.filter === "Y") return <span key={key}>YES</span>;
    if (value.filter === "N") return <span key={key}>NO</span>;
    else return <span key={key}>{value.filter}</span>;
  }
  if (symbol === "between") {
    const [from, to] = value.filter?.split("|");
    return <span key={key}>{`${from} to ${to}`}</span>;
  } else {
    return value.filter;
  }
};

export const TransformlabelValueItem = (props: {
  item: PropsItem;
  filterList?: Array<PropsItem>;
}) => {
  const { item, filterList } = props;
  const { key, value } = item;
  const filterVal = value.filter;
  const symbol = TypeMapping[value.type] || "";
  if (filterVal !== "") {
    if (key.startsWith("accountSegmentation")) {
      return (
        <span key={key}>{`${symbol} ${filterVal?.toString().substr(0, 30)} ${
          filterVal?.length > 30 ? "..." : ""
        }`}</span>
      );
    }
    switch (key) {
      case "externalEPFilter":
        const [epValue] = filterVal.split("+");
        return <span key={key}>{epValue}</span>;
      case "externalKeyword":
        break;
      // case "externalAlertFilter":
      //   break;

      case "renewalFactors":
        return (
          <span key={key}>
            {value.filter
              .split("|")
              .map((i) => factorMappings.find((j) => j.code === i)?.value)
              .join()}
          </span>
        );
      case "externalSearch":
        const [_includeInactive, ...criteria] = filterVal.split("%|%");
        const keyword =
          filterList?.filter((i) => i.key === "externalKeyword")[0]?.value?.filter ||
          criteria.join("%|%");
        if (!criteria.length || keyword === "") return null;
        return (
          <span key={key}>
            <span style={{ textTransform: "capitalize" }}>keyword</span>
            {` = ${keyword}`}
          </span>
        );
      case "externalInactiveSite":
        return <span key={key}>{`${symbol} ${filterVal === "false"}`}</span>;
      case "arOffPCCount":
        return <span key={key}>{`${symbol} ${filterVal === "1" ? "Yes" : "No"}`}</span>;
      case "partnerAccountName":
        return (
          <span key={key}>{`${symbol} ${filterVal
            ?.replace(/(Non-){0,1}Lifecycle%-%/g, "")
            .substr(0, 30)} ${filterVal?.length > 30 ? "..." : ""}`}</span>
        );
      // case "renewalDate":
      // case "forecastingModifiedTime":
      //   const [from, to] = filterVal?.split("|");
      //   return <span key={key}>{`${from} to ${to}`}</span>;
      case "foundationalSetup-hasClaimedDomain":
        return <span key={key}>{` ${symbol} ${filterVal}`}</span>;
      case "collabMapUploadedDate":
        return (
          <span key={key}>{`${symbol === "notEquals" ? "" : symbol} ${filterVal} 
                  `}</span>
        );

      default:
        const val = filterVal?.toString().replaceAll("null", "None");
        if (symbol === "in") {
          return <span key={key}>{val?.toString().split("|").join(", ")}</span>;
        }
        if (symbol === "equals") {
          if (value.filter === "Y") return <span key={key}>YES</span>;
          if (value.filter === "N") return <span key={key}>NO</span>;
          else return <span key={key}>{value.filter}</span>;
        }
        if (symbol === "between") {
          const [from, to] = filterVal?.split("|");
          return <span key={key}>{`${from} to ${to}`}</span>;
        }
        return (
          <span key={key}>
            {symbol} {val?.toString().substr(0, 30)}
          </span>
        );
    }
  }
};
